// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-container {
}
.date-container > :last-child {
  margin-top: 1vmin;
  padding: 1vmin;
  border: 2px solid red;
}
.date-range-container-2 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}
.date-range-container-2 > div {
  display: flex;
  position: relative;
}

.date-range-container-2 > div > div {
  /* width: 6.8rem ;
  height: 2.5rem; */

  width: 7.2rem;
  height: 2.7rem;
  padding: 0.5rem 0.7rem;
  margin: 0 0.3rem;
  border: none;
  /* background-color: #203864; */
  box-shadow: 1px 2px 3px black;
  border-radius: 4px;
  /* color: white; */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  position: relative;
  /* background-color: rgb(4, 135, 172); */
  background-color:#ed7d31;
  
  /* color: #fff; */
  color: black;
  font-weight: 1000;
  cursor: pointer;
}

.date-range-container-2 > div > div > div {
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 0.8rem;
}

.date-range-container-2 .rotate {
  transform: scaleY(-1);
  /* transform: rotate(-180deg); */
  transition: 0.2s ease-out;
}
.date-range-container-2 .not-rotate {
  /* transform: rotate(0deg); */

  transform: scaleY(1);
  transition: 0.2s ease-out;
}
.date-range-container-2 .selected {
  /* background-color: rgb(4, 111, 141); */
  background-color:#ed7d31 ;
  
}
.date-range-container-2 .selected-label {
  /* background-color: rgb(3, 99, 125); */
  background-color:#ed7d31;
}
.label-drop-down-container {
  position: absolute;
  top: 110%;
  right: 0;
  left: 0;
  color: black;
  height: 0;
  overflow: hidden;
  background-color: #fff;
  cursor: auto;
  border-radius: 8px;
}

.label-drop-down-container.show {
  position: absolute;
  height: auto;
  overflow: auto;
  /* padding: 0.3rem; */
  z-index: 2;
  box-shadow: 1px 2px 3px black;
  border: 1px solid rgb(4, 135, 172);
}
.label-drop-down-container > span {
  text-align: center;
  font-size: 0.7rem;
  padding: 0.6rem 0.3rem;
  width: 100%;
  cursor: pointer;
  background-color: #fff;
  /* background-color: aliceblue; */
  /* border-radius: 18px; */
}
.label-drop-down-container > :not(:last-child) {
  /* border-bottom: 1px solid wheat; */
}
.label-drop-down-container > span:hover {
  background-color: rgb(216, 234, 250);
}
.label-drop-down-container .selected {
  background-color: rgb(195, 222, 246);
}

.calender-container {
  position: absolute;
  top: 110%;
  right: 0;
  left: -100%;
  color: black;
  height: 0;
  border-radius: 8px;
  overflow: hidden;
  /* transition: 0.2s ease-out; */
  background-color: #fff;
  /* background-color: rgb(4, 111, 141);
  color: #e3dfdf; */
  z-index: 2;
  cursor: auto;
}
.date-range-container-2 .show2,
.date-range-container-2 .show3 {
  position: absolute;
  height: auto;
  min-height: 200px;
  width: 250px;
  overflow: auto;
  box-shadow: 1px 2px 3px black;
  border: 1px solid rgb(4, 135, 172);
}
.date-range-container-2 .show3 {
  left: -120%;
}

/* color: green antiquewhite #fff black; */

.calender-container > :first-child .active-date-label {
  /* background-color: rgb(3, 139, 3); */
  /* color: #fff; */
}

.calender-container > :first-child .active-disabled-date-label {
  opacity: 0.4;
}
.calender-container > :first-child {
  position: sticky;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
}
.calender-container > :first-child span {
  flex: 1 1;
  padding: 0.6rem 0.3rem;
  background-color: antiquewhite;
  cursor: pointer;
  text-align: center;
  color: black;
  opacity: 1;
}
.calender-container > :first-child > :not(:last-child) {
  border-right: 1px solid rgb(219, 203, 182);
}

.calender-container > :first-child span:hover {
  background-color: rgb(223, 187, 139);
}

.calender-container > :first-child .open {
  background-color: rgb(252, 220, 178);
}
.calender-container > :last-child {
  width: 100%;
  padding: 0.6rem;
  width: 100%;
  display: grid;
  grid: auto/auto auto auto auto;
  align-items: center;
  gap: 0.6rem 0.8rem;
}
.calender-container > :last-child > div {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  text-align: center;
}
.calender-container > :last-child > div > :first-child {
  border-right: 1px solid rgb(219, 203, 182);
}
.calender-container > :last-child > div > span {
  flex: 1 1;
  padding: 0.6rem 0.3rem;
  background-color: antiquewhite;
  cursor: pointer;
}
.calender-container > :last-child > div > span:hover {
  background-color: rgb(223, 187, 139);
}
.calender-container > :last-child > span {
  text-align: center;
  padding: 0.5rem 0.3rem;
  cursor: pointer;
  border-radius: 10px;
  background-color: rgb(223, 250, 250);
  font-size: 0.7rem;
}
.calender-container > :last-child .active-date-value {
  background-color: rgb(186, 228, 228) !important;
  background-color: rgb(112, 215, 215) !important;
}
.calender-container > :last-child > span:hover {
  background-color: rgb(223, 250, 250);
  background-color: rgb(178, 239, 239);
}
@media screen and (max-width: 450px) {
  .date-range-container-2 {
    gap: 0.5rem;
  }
  .date-range-container-2 .show2 {
    left: 0;
  }
  .date-range-container-2 .show3 {
    right: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/daterange2.css"],"names":[],"mappings":"AAAA;AACA;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;mBACiB;;EAEjB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,wBAAwB;;EAExB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,6BAA6B;;EAE7B,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,wCAAwC;EACxC,yBAAyB;;AAE3B;AACA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,UAAU;EACV,6BAA6B;EAC7B,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB;mBACiB;EACjB,UAAU;EACV,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,6BAA6B;EAC7B,kCAAkC;AACpC;AACA;EACE,WAAW;AACb;;AAEA,0CAA0C;;AAE1C;EACE,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,SAAO;EACP,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,+CAA+C;EAC/C,+CAA+C;AACjD;AACA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,OAAO;EACT;EACA;IACE,QAAQ;EACV;AACF","sourcesContent":[".date-container {\r\n}\r\n.date-container > :last-child {\r\n  margin-top: 1vmin;\r\n  padding: 1vmin;\r\n  border: 2px solid red;\r\n}\r\n.date-range-container-2 {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1.5rem;\r\n  flex-wrap: wrap;\r\n}\r\n.date-range-container-2 > div {\r\n  display: flex;\r\n  position: relative;\r\n}\r\n\r\n.date-range-container-2 > div > div {\r\n  /* width: 6.8rem ;\r\n  height: 2.5rem; */\r\n\r\n  width: 7.2rem;\r\n  height: 2.7rem;\r\n  padding: 0.5rem 0.7rem;\r\n  margin: 0 0.3rem;\r\n  border: none;\r\n  /* background-color: #203864; */\r\n  box-shadow: 1px 2px 3px black;\r\n  border-radius: 4px;\r\n  /* color: white; */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: row;\r\n  position: relative;\r\n  /* background-color: rgb(4, 135, 172); */\r\n  background-color:#ed7d31;\r\n  \r\n  /* color: #fff; */\r\n  color: black;\r\n  font-weight: 1000;\r\n  cursor: pointer;\r\n}\r\n\r\n.date-range-container-2 > div > div > div {\r\n  white-space: nowrap;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.date-range-container-2 .rotate {\r\n  transform: scaleY(-1);\r\n  /* transform: rotate(-180deg); */\r\n  transition: 0.2s ease-out;\r\n}\r\n.date-range-container-2 .not-rotate {\r\n  /* transform: rotate(0deg); */\r\n\r\n  transform: scaleY(1);\r\n  transition: 0.2s ease-out;\r\n}\r\n.date-range-container-2 .selected {\r\n  /* background-color: rgb(4, 111, 141); */\r\n  background-color:#ed7d31 ;\r\n  \r\n}\r\n.date-range-container-2 .selected-label {\r\n  /* background-color: rgb(3, 99, 125); */\r\n  background-color:#ed7d31;\r\n}\r\n.label-drop-down-container {\r\n  position: absolute;\r\n  top: 110%;\r\n  right: 0;\r\n  left: 0;\r\n  color: black;\r\n  height: 0;\r\n  overflow: hidden;\r\n  background-color: #fff;\r\n  cursor: auto;\r\n  border-radius: 8px;\r\n}\r\n\r\n.label-drop-down-container.show {\r\n  position: absolute;\r\n  height: auto;\r\n  overflow: auto;\r\n  /* padding: 0.3rem; */\r\n  z-index: 2;\r\n  box-shadow: 1px 2px 3px black;\r\n  border: 1px solid rgb(4, 135, 172);\r\n}\r\n.label-drop-down-container > span {\r\n  text-align: center;\r\n  font-size: 0.7rem;\r\n  padding: 0.6rem 0.3rem;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  background-color: #fff;\r\n  /* background-color: aliceblue; */\r\n  /* border-radius: 18px; */\r\n}\r\n.label-drop-down-container > :not(:last-child) {\r\n  /* border-bottom: 1px solid wheat; */\r\n}\r\n.label-drop-down-container > span:hover {\r\n  background-color: rgb(216, 234, 250);\r\n}\r\n.label-drop-down-container .selected {\r\n  background-color: rgb(195, 222, 246);\r\n}\r\n\r\n.calender-container {\r\n  position: absolute;\r\n  top: 110%;\r\n  right: 0;\r\n  left: -100%;\r\n  color: black;\r\n  height: 0;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  /* transition: 0.2s ease-out; */\r\n  background-color: #fff;\r\n  /* background-color: rgb(4, 111, 141);\r\n  color: #e3dfdf; */\r\n  z-index: 2;\r\n  cursor: auto;\r\n}\r\n.date-range-container-2 .show2,\r\n.date-range-container-2 .show3 {\r\n  position: absolute;\r\n  height: auto;\r\n  min-height: 200px;\r\n  width: 250px;\r\n  overflow: auto;\r\n  box-shadow: 1px 2px 3px black;\r\n  border: 1px solid rgb(4, 135, 172);\r\n}\r\n.date-range-container-2 .show3 {\r\n  left: -120%;\r\n}\r\n\r\n/* color: green antiquewhite #fff black; */\r\n\r\n.calender-container > :first-child .active-date-label {\r\n  /* background-color: rgb(3, 139, 3); */\r\n  /* color: #fff; */\r\n}\r\n\r\n.calender-container > :first-child .active-disabled-date-label {\r\n  opacity: 0.4;\r\n}\r\n.calender-container > :first-child {\r\n  position: sticky;\r\n  top: 0;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.calender-container > :first-child span {\r\n  flex: 1;\r\n  padding: 0.6rem 0.3rem;\r\n  background-color: antiquewhite;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  color: black;\r\n  opacity: 1;\r\n}\r\n.calender-container > :first-child > :not(:last-child) {\r\n  border-right: 1px solid rgb(219, 203, 182);\r\n}\r\n\r\n.calender-container > :first-child span:hover {\r\n  background-color: rgb(223, 187, 139);\r\n}\r\n\r\n.calender-container > :first-child .open {\r\n  background-color: rgb(252, 220, 178);\r\n}\r\n.calender-container > :last-child {\r\n  width: 100%;\r\n  padding: 0.6rem;\r\n  width: 100%;\r\n  display: grid;\r\n  grid: auto/auto auto auto auto;\r\n  align-items: center;\r\n  gap: 0.6rem 0.8rem;\r\n}\r\n.calender-container > :last-child > div {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  display: flex;\r\n  text-align: center;\r\n}\r\n.calender-container > :last-child > div > :first-child {\r\n  border-right: 1px solid rgb(219, 203, 182);\r\n}\r\n.calender-container > :last-child > div > span {\r\n  flex: 1;\r\n  padding: 0.6rem 0.3rem;\r\n  background-color: antiquewhite;\r\n  cursor: pointer;\r\n}\r\n.calender-container > :last-child > div > span:hover {\r\n  background-color: rgb(223, 187, 139);\r\n}\r\n.calender-container > :last-child > span {\r\n  text-align: center;\r\n  padding: 0.5rem 0.3rem;\r\n  cursor: pointer;\r\n  border-radius: 10px;\r\n  background-color: rgb(223, 250, 250);\r\n  font-size: 0.7rem;\r\n}\r\n.calender-container > :last-child .active-date-value {\r\n  background-color: rgb(186, 228, 228) !important;\r\n  background-color: rgb(112, 215, 215) !important;\r\n}\r\n.calender-container > :last-child > span:hover {\r\n  background-color: rgb(223, 250, 250);\r\n  background-color: rgb(178, 239, 239);\r\n}\r\n@media screen and (max-width: 450px) {\r\n  .date-range-container-2 {\r\n    gap: 0.5rem;\r\n  }\r\n  .date-range-container-2 .show2 {\r\n    left: 0;\r\n  }\r\n  .date-range-container-2 .show3 {\r\n    right: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
